var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9601 18.4C32.7554 18.4 33.4076 17.7537 33.3282 16.9624C33.1437 15.1237 32.6065 13.3331 31.7413 11.6902C30.6519 9.62143 29.075 7.84905 27.1471 6.52624C25.2192 5.20342 22.9982 4.36995 20.6759 4.09785C18.8317 3.88175 16.9678 4.02487 15.1859 4.51432C14.419 4.72498 14.0507 5.56602 14.3368 6.30804C14.623 7.05006 15.4555 7.41007 16.2274 7.21865C17.5679 6.88623 18.9613 6.79663 20.3408 6.95828C22.1985 7.17596 23.9754 7.84274 25.5177 8.90099C27.06 9.95924 28.3215 11.3771 29.1931 13.0322C29.8403 14.2611 30.258 15.5934 30.4302 16.9637C30.5294 17.7528 31.1648 18.4 31.9601 18.4Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/Loading.c3d63955840268abda7473de60f54039.svg";
export { ForwardRef as ReactComponent };